import { useContext, useEffect, useMemo } from 'react';

import { Menu } from './menu';
import { Drawer } from './drawer';
import { Color } from '../../../types/theme';
import { hexToRGB } from '../../../utils/hex-to-rgb';
import { OverlayContext } from '../../../contexts/overlay';
import { TradeStateContext } from '../../../contexts/trade';
import { GameDocumentContext } from '../../../contexts/game-document';
import { TimerProgressBar } from '../../../components/timer/progress-bar';

export const Overlay = () => {
  const [trade] = useContext(TradeStateContext);
  const [gameDocument] = useContext(GameDocumentContext);
  const [overlay, setOverlay] = useContext(OverlayContext);

  const theme: Color[] = gameDocument?.theme?.colors ?? [];

  const getFooterImage = () => ({
    background: `url(${gameDocument?.theme?.footerUrl ?? ''} )`,
    backgroundSize: `cover`,
    backgroundPosition: `center`
  });

  const isOnTradingSession = useMemo(() => {
    const offer = ['Draft', 'Pending'].includes(trade.offerPlayerStatus);
    const request = ['Draft', 'Pending'].includes(trade.requestPlayerStatus);
    return (
      [offer, request].every((e) => e) ||
      [trade.offerPlayerStatus, trade.requestPlayerStatus].some(
        (e) => e === 'Accepted'
      )
    );
  }, [trade.offerPlayerStatus, trade.requestPlayerStatus]);

  useEffect(() => {
    if (theme) {
      const backgroundColor = theme.find((x) => x.type === 'Background & Text');

      if (backgroundColor) {
        const { color } = backgroundColor;
        const menu = document.getElementsByClassName('overlay__menu');
        const drawer = document.getElementsByClassName('overlay__drawer');

        const background = color
          ? hexToRGB(color).replace(
              '1)',
              overlay.drawerIsOpen ? '0.85)' : '0.2)'
            )
          : `rgba(0,58,100, ${overlay.drawerIsOpen ? '0.85' : '0.2'})`;

        if (menu.length > 0) {
          (menu[0] as HTMLElement).style.background = background;
        }

        if (drawer.length > 0) {
          (drawer[0] as HTMLElement).style.background = background;
        }
      }
    }
  }, [theme, overlay.drawerIsOpen]);

  return (
    <div
      className={`game__overlay game__overlay--${
        overlay.drawerIsOpen ? 'active' : 'in-active'
      }`}>
      <div className={'overlay__menu'}>
        <TimerProgressBar />
        <Menu />
      </div>
      <div className={'overlay__drawer'}>
        <TimerProgressBar />
        <Drawer />
      </div>
      {overlay.drawerIsOpen && (
        <div
          className={'overlay__footer'}
          style={getFooterImage()}
          {...(!isOnTradingSession && {
            onClick: () =>
              setOverlay((prev) => ({
                ...prev,
                drawerIsOpen: false,
                drawerMobileIsOpen: false
              }))
          })}
        />
      )}
    </div>
  );
};
